export var TypographyLevel;
(function (TypographyLevel) {
    TypographyLevel["BodyXs"] = "body-xs";
    TypographyLevel["BodySm"] = "body-sm";
    TypographyLevel["BodyMd"] = "body-md";
    TypographyLevel["Paragraph"] = "paragraph";
})(TypographyLevel || (TypographyLevel = {}));
